import { render, staticRenderFns } from "./InstrumentsKeyboard.vue?vue&type=template&id=2c264615"
import script from "./InstrumentsKeyboard.vue?vue&type=script&lang=js"
export * from "./InstrumentsKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports